export const UPDATE_CUSTOM_BREADCRUMBS = '[APP] UPDATE_CUSTOM_BREADCRUMBS';
export const UPDATE_TOP_HEADER_TITLE = '[APP] UPDATE_TOP_HEADER_TITLE';